const DOMAIN = 'logo_maker';

const addDomainPrefix = (name) => `${DOMAIN}.${name}`;

module.exports = { addDomainPrefix };
